import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import useLoggedInCustomer from "../../../../shared/hooks/useLoggedInCustomer";
import { AddToCartCard } from "../card";


export type AddToCartMultiProps = {
    product: Queries.ProductDetailPageQuery['product']
    variantId: string
    quantityDescription: string
    selectedQuantity: number
    setSelectedQuantity?: (quantity: number) => void
}

export const AddToCartMulti = ({ product, variantId, quantityDescription, selectedQuantity, setSelectedQuantity }: AddToCartMultiProps) => {
    const [options, setOptions] = useState<number[]>([3, 2, 1]);

    const { wholesale } = useLoggedInCustomer()

    useEffect(() => {
        if (!wholesale) setOptions([3, 2, 1]);
        else setOptions([10, 30, 50, 100, 200])
    }, [wholesale])

    return (
        <Stack direction='column' gap={{ xs: 1, sm: 1, md: 2 }} alignItems={'center'} justifyContent={'center'} sx={{ width: '100%' }}>
            {options.map(o => <AddToCartCard key={o} product={product} variantId={variantId} quantity={o} quantityDescription={quantityDescription} selectedQuantity={selectedQuantity} setSelectedQuantity={setSelectedQuantity} />)}
        </Stack>
    )
}